import store from '@/store'

export const resourceIdTransName = (type, id) => {
  const cacheData = store.state.privateCloud.cacheData
  if (cacheData[type] && cacheData[type][id]) {
    return cacheData[type][id].name
  } else {
    return id
  }
}

export const resourceIdTransObject = (type, id) => {
  const cacheData = store.state.privateCloud.cacheData
  if (cacheData[type] && cacheData[type][id]) {
    return cacheData[type][id]
  } else {
    return null
  }
}
